import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource, MatSnackBar } from '@angular/material';
import { User } from '../../../autentication/models/user';
import { Auth } from '../../../autentication/Auth';
import { PixKeysService } from '../keys/keys.service';
import { PixKey } from '../models/key.model';
import { Router } from '@angular/router';
import { PixQrCode } from '../models/qr-code.model';
import { Util } from '../../../utils/util';
import { PixGenerateQrCode } from '../models/generate-qrcode.model';
import { PixAntiFraudModalComponent } from '../payment-key/modal/anti-fraud/anti-fraud.component';

@Component({
	selector: 'app-pix-my-qr-code',
	templateUrl: './my-qr-code.component.html',
	styleUrls: ['./my-qr-code.component.styl'],
})
export class PixMyQrCodeComponent implements OnInit {

	public user: User;
	public mainKey: PixKey;
	public qrCode: PixQrCode;

	constructor(
		public dialogRef: MatDialogRef<PixAntiFraudModalComponent>,
		private pixKeysService: PixKeysService,
		private snackBar: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {
		if (data) {
			this.mainKey = data;
		} else {
			this.onClose();
		}
	}

	ngOnInit(): void {
		this.user = Auth.getInstance().getUser();
		this.getQrCode();
	}

	getQrCode() {
		const request = new PixGenerateQrCode(this.mainKey.codigo, this.mainKey.tipoChave, null, 'D', null, 'ESTATICO', null);

		this.pixKeysService.getQrCode(request).subscribe(data => {
			if (data.Existe && data.Sucesso) {
				this.qrCode = Util.keysToCamel(data.Retorno) as PixQrCode;
			}
		});
	}

	copyMessage(val: string) {
		Util.copyToClipboard(val);
		this.showSnack();
	}

	showSnack() {
		this.snackBar.open('Copiado', 'Ok', {
			duration: 2000,
		});
	}

	onClose = () => this.dialogRef.close();
	onConfirm = () => this.dialogRef.close(true);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/my-qr-code/my-qr-code.component.ts